/* eslint-disable jira/filename-case */
export const RESOURCE_TYPE_PROJECT_WORKFLOW_CONTEXT = 'PROJECT_WORKFLOW_CONTEXT';
